import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Image from '@loggi/ui/components/image';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import clipart from 'images/address-success.png';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

export default function SuccessHeader(props) {
  const { user, company, onClick } = props;

  const HEADER_BUTTON_TEXT = 'Acompanhar pedido';

  const SuccessGreetings = () => {
    const userName = (
      <Text large bold color={colors.type.WHITE}>
        {user}
      </Text>
    );
    const companyName = (
      <Text large bold color={colors.type.WHITE}>
        {company}
      </Text>
    );

    return (
      <Col
        data-testid="success-greetings"
        gutter={{ top: 'normal', bottom: 'normal' }}
      >
        <Text large color={colors.type.WHITE}>
          Pronto, {userName}! Agora você pode acompanhar seu pedido{' '}
          {companyName}.
        </Text>
      </Col>
    );
  };

  return (
    <Fragment data-testid="teste-header">
      <Image
        data-testid="success-header-clipart"
        src={clipart}
        noBackgroundColor
      />
      {user && company && <SuccessGreetings />}
      <Button
        data-testid="go-to-package-status"
        value={HEADER_BUTTON_TEXT}
        onClick={onClick}
        style="light"
        shape="rounded"
        size="small"
      />
    </Fragment>
  );
}

SuccessHeader.propTypes = {
  user: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

SuccessHeader.displayName = 'SuccessHeader';
